import containerFuild from '../html-snippets/container-fuild';
import css from '../css-snippets/section-policy-yuri-accordion';
const html = `
<div data-show-title="true" data-attribute="card-title" class="title-card">

</div>
<div data-attribute="card-accordions" class="card-accordions" data-show-accordion="true" style="display: block;">
  <div data-attribute="card-accordion" class="wrap-accordion">
    <div data-attribute="accordion-title" class="accordion-title">
      <div data-attribute="accordion-title-text">Description</div>
      <div class="accordion-icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>plus</title>
          <path d="M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z" fill="currentColor"></path>
        </svg>
      </div>
    </div>
    <div data-attribute="accordion-content" class="accordion-content">
      <div data-attribute="accordion-text" class="accordion-text">
        <p>Unlike ordinary peel-off masks, Yuri’s lightweight collagen-infused veil works in harmony with your skin’s
          natural renewal cycle. While you sleep, it creates a breathable wrap that delivers continuous 8-hour
          care—supporting firmness, replenishing moisture, and smoothing the look of tired skin. By sunrise, the mask
          lifts away in one clean piece, leaving behind only comfort and clarity.</p>
        <p>Rooted in advanced Korean skincare science, this formula blends powerful actives with skin-kind technology
          for results that are visible, yet gentle enough for nightly use. The result? Skin that feels firmer, dewier,
          and effortlessly luminous—without the fuss.</p>
        <ul>
          <li>Dermatologist tested</li>
          <li>Proven low-irritation formula</li>
          <li>Free from artificial colorants &amp; fragrances</li>
          <li>Thoughtfully packaged with sustainability in mind</li>
          <li>Net wt. 2.53 fl. oz. / 75 ml</li>
        </ul>
      </div>
    </div>
  </div>

  <div data-attribute="card-accordion" class="wrap-accordion">
    <div data-attribute="accordion-title" class="accordion-title">
      <div data-attribute="accordion-title-text">How to use</div>
      <div class="accordion-icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>plus</title>
          <path d="M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z" fill="currentColor"></path>
        </svg>
      </div>
    </div>
    <div data-attribute="accordion-content" class="accordion-content">
      <div data-attribute="accordion-text" class="accordion-text">
        <ol>
          <li><strong>Prep your skin</strong> – After cleansing, follow your routine up to toner or cream, ensuring your
            face is clean and well-hydrated.</li>
          <li><strong>Apply the mask</strong> – Using a brush or spatula, spread an even layer of the wrapping mask over
            your face. Avoid the eyebrows, hairline, eyes, and lips.</li>
          <li><strong>Overnight care</strong> – Allow the mask to set for about 15 minutes, then leave it on overnight
            while your skin rejuvenates as you sleep.</li>
          <li><strong>Morning reveal</strong> – Gently peel the mask away from the edges in one piece, or rinse with
            lukewarm water to uncover refreshed, radiant skin.</li>
        </ol>
      </div>
    </div>
  </div>

  <div data-attribute="card-accordion" class="wrap-accordion">
    <div data-attribute="accordion-title" class="accordion-title">
      <div data-attribute="accordion-title-text">Clinically Proven Results</div>
      <div class="accordion-icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>plus</title>
          <path d="M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z" fill="currentColor"></path>
        </svg>
      </div>
    </div>
    <div data-attribute="accordion-content" class="accordion-content">
      <div data-attribute="accordion-text" class="accordion-text">
        <p>Backed by a self-test study, <strong>Yuri’s Collagen Night Wrapping Mask</strong> delivers visible
          improvements in skin hydration, firmness, and overall barrier health.</p>
        <ul>
          <li><strong>+31.4%</strong> increase in skin elasticity (after 2 weeks)</li>
          <li><strong>-4.5%</strong> reduction in trans-epidermal water loss (after 2 weeks)</li>
          <li><strong>+24.8%</strong> improvement in 24-hour moisture retention (after just 1 use)</li>
          <li><strong>+23.4%</strong> boost in surface hydration (after 2 weeks)</li>
          <li><strong>+2.9%</strong> increase in deep hydration (after 2 weeks)</li>
        </ul>
      </div>
    </div>
  </div>

  <div data-attribute="card-accordion" class="wrap-accordion">
    <div data-attribute="accordion-title" class="accordion-title">
      <div data-attribute="accordion-title-text">Ingredients</div>
      <div class="accordion-icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>plus</title>
          <path d="M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z" fill="currentColor"></path>
        </svg>
      </div>
    </div>
    <div data-attribute="accordion-content" class="accordion-content">
      <div data-attribute="accordion-text" class="accordion-text">
        <ul>
          <li><strong>Hyaluronic Acid</strong> – Deep hydration that plumps skin and softens fine lines.</li>
          <li><strong>Niacinamide (Vitamin B3)</strong> – Refines texture, minimizes pores, and brightens for a healthy
            glow.</li>
          <li><strong>Glycerin</strong> – Locks in moisture and strengthens the skin barrier.</li>
          <li><strong>Vitamin E (Tocopherol)</strong> – Antioxidant protection that nourishes and smooths.</li>
          <li><strong>Ceramide NP</strong> – Restores barrier function and defends against dryness and damage.</li>
          <li><strong>Collagen Extract</strong> – Boosts elasticity, hydration, and youthful resilience.</li>
          <li><strong>Adenosine</strong> – Supports skin renewal and visibly reduces fine lines.</li>
          <li><strong>Butylene Glycol</strong> – Enhances moisture retention and ingredient absorption.</li>
        </ul>
      </div>
    </div>
  </div>
</div>
`;
export default containerFuild(html, css);
